import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

import {
  homeConstants,
  propertyConstants,
  subscriptionConstants,
} from "../../constants";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import MainContentWrapper from "../../shared/components/main-content-wrapper/MainContentWrapper";
import Topbar from "../../layout/Topbar";
import Footer from "../../layout/Footer";
import FreshProperty from "../property/FreshProperty";
import PropertyType from "../property-type/PropertyType";
import CountryBanner from "../country-banner/CountryBanner";
import FavouritesProperty from "../property/FavouritesProperty";
import RecommendedProperty from "../property/RecommendedProperty";
// Destructure constants
const { ALL_PROPERTY_TYPES } = propertyConstants;
const { GET_USER_SUBSCRIPTION_STATUS } = subscriptionConstants;
const { ALL_ALLOWED_COUNTRIES, ALL_MUST_HAVE_AMMENITIES } = homeConstants;

const Home = ({ spinnerActions, isAuthenticated }) => {
  const [amenities, setAmenities] = useState([]);
  const [filters, setFilters] = useState({
    countryIds: [],
    propertyTypeIds: [],
  });

  // Memoized callback to check if a specific spinner type is active
  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  return (
    <>
      {/* Render Spinner if any spinner type is active and user is authenticated */}
      {(spinner(ALL_PROPERTY_TYPES) > -1 ||
        spinner(ALL_ALLOWED_COUNTRIES) > -1 ||
        spinner(ALL_MUST_HAVE_AMMENITIES) > -1 ||
        spinner(GET_USER_SUBSCRIPTION_STATUS) > -1) &&
        isAuthenticated && <MainSpinner />}

      {/* Topbar for navigation or header content */}
      <Topbar />
      {/* Main content wrapper to house all sections */}
      <MainContentWrapper>
        {/* Banner displaying countries */}
        <CountryBanner filters={filters} setFilters={setFilters} />
        {/* Section to display property types */}
        <PropertyType
          filters={filters}
          setFilters={setFilters}
          setAmenities={setAmenities}
        />
        {/* Section for newly added properties */}
        <FreshProperty filters={filters} />
        {/* Section displaying recommended properties */}
        <RecommendedProperty filters={filters} amenities={amenities} />
        {/* Section for user's favorite properties */}
        <FavouritesProperty filters={filters} />
        {/* Footer component */}
        <Footer />
      </MainContentWrapper>
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
  isAuthenticated: state.authReducer.isAuthenticated,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = {};

// Mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(Home);
